export default __webpack_public_path__ + "static/media/Julie@2x.ca5e4dea.jpg";